import React from 'react';
import { InfoPagesLayout } from 'Components/InfoPagesLayout/InfoPagesLayout';

export const SuccessPassResetPage = () => (
  <InfoPagesLayout>Your password was successfully reset.</InfoPagesLayout>
);
